import dotenv from "dotenv";
dotenv.config();
const {
  REACT_APP_API_URL,
  REACT_APP_API_PUBLIC_URL,
  REACT_APP_FRAME_PARENT_URL,
  REACT_APP_REPORT_URL,
  REACT_APP_DOWNLOAD_URL,
  REACT_APP_IS_IFRAME,
  REACT_APP_EXTERNAL_API,
  REACT_APP_API_CUSTOM_CDR,
  APP_THEME_NAME,
  REACT_APP_CUSTOM_CDR_DOWNLOAD_URL,
  REACT_APP_CLOUD_ICON,
  REACT_APP_CLOUD_MENU_ICON,
  REACT_APP_PROVIDER_RESTRICT,
  REACT_APP_CLOUD_MOBILE_MENU_ICON,
  REACT_APP_SHORTCUT_ICON,
  REACT_APP_BACKDROP_ICON,
  REACT_APP_CLOUD_FLARE_KEY,
  REACT_APP_IS_CUSTOMER_LOGIN
} = process.env;
// eslint-disable-next-line no-restricted-globals
const loc = location.hostname;
export const apiUrl = REACT_APP_API_URL
  ? REACT_APP_API_URL
  : `https://cloud-global-dev.streamspace.ai/v1/auth/`;

export const apiUrlPublic = REACT_APP_API_PUBLIC_URL
  ? REACT_APP_API_PUBLIC_URL
  : `https://cloud-global-dev.streamspace.ai/v1/`;
//COMPULSORY USE ENV FOR THIS
export const apiFrameParentUrl = REACT_APP_FRAME_PARENT_URL;

export const reportUrl = REACT_APP_REPORT_URL
  ? REACT_APP_REPORT_URL
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

export const customCDR = REACT_APP_API_CUSTOM_CDR
  ? REACT_APP_API_CUSTOM_CDR
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

export const downloadCustomCDR = REACT_APP_CUSTOM_CDR_DOWNLOAD_URL
  ? REACT_APP_CUSTOM_CDR_DOWNLOAD_URL
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;

export const downloadUrl = REACT_APP_DOWNLOAD_URL
  ? REACT_APP_DOWNLOAD_URL
  : `https://alpha-cloud.streamspace.ai/v1/auth/`;
export const externalApi = "";

export const app_theme = APP_THEME_NAME || "tcc1";

export const modalType = app_theme === "tcc1" ? "right" : "";

export const leftSidebarType = app_theme === "tcc1" ? false : true;

export const providerRestrict =
  REACT_APP_PROVIDER_RESTRICT == "true" ? true : false;
export const companyIcon = REACT_APP_CLOUD_ICON
  ? REACT_APP_CLOUD_ICON
  : "LoginLogo.svg";
export const companyMenuIcon = REACT_APP_CLOUD_MENU_ICON
  ? REACT_APP_CLOUD_MENU_ICON
  : "SS_LOGO.png";
export const shortcutIcon = REACT_APP_SHORTCUT_ICON
  ? REACT_APP_SHORTCUT_ICON
  : "streamlogo.png";
export const companyMobileMenuIcon = REACT_APP_CLOUD_MOBILE_MENU_ICON
  ? REACT_APP_CLOUD_MOBILE_MENU_ICON
  : "streamlogo.png";
export const companyBackdropIcon = REACT_APP_BACKDROP_ICON
  ? REACT_APP_BACKDROP_ICON
  : "modal_stream_logo.png";

export const cloudFlareKey = REACT_APP_CLOUD_FLARE_KEY
  ? REACT_APP_CLOUD_FLARE_KEY
  : "0x4AAAAAAAb8SBFIo3u-aKN0";

export const isCustomerLogin = REACT_APP_IS_CUSTOMER_LOGIN === "true" ? true : false;

export const globalUrlList = [
  "/organization",
  "/organization-settings",
  "/organization-settings/region",
  "/organization-settings/flow-template",
  "/organization-settings/tts-provider",
  "/organization-settings/tts-model",
  "/organization-settings/stt-provider",
  "/organization-settings/stt-model",
  "/organization-settings/llm-provider",
  "/organization-settings/llm-model",
  // Add more URLs as needed
];



// WEBPACK FOOTER //
// src/helpers/dotenv.js